import { useIntl } from 'react-intl';
import moment from 'moment';
import { Col, Input, Row } from 'antd';

import { ListWorkOrdersQuery } from '@/core/domain/workorder/WorkOrders/WorkOrders.types';

import { ExtraFiltersProps } from '@/types/ExtraFiltersProps';
import { InputDate } from '@/components/_common';

function ModalWorkOrdersExtraFilters({
  queryParams,
  setQueryParams,
}: ExtraFiltersProps<ListWorkOrdersQuery>) {
  const intl = useIntl();

  return (
    <Row gutter={[24, 24]}>
      <Col xs={24} md={6}>
        <Input
          value={queryParams?.number}
          onChange={({ target: { value } }) =>
            setQueryParams((prev) => ({ ...prev, number: value }))
          }
          placeholder={intl.formatMessage({
            id: 'workOrders.domain.number',
          })}
        />
      </Col>

      <Col xs={24} md={6}>
        <Input
          value={queryParams?.licensePlate}
          onChange={({ target: { value } }) =>
            setQueryParams((prev) => ({ ...prev, licensePlate: value }))
          }
          placeholder={intl.formatMessage({
            id: 'workOrders.domain.vehicle.licensePlate',
          })}
        />
      </Col>

      <Col xs={24} md={6}>
        <Input
          value={queryParams?.customer}
          onChange={({ target: { value } }) =>
            setQueryParams((prev) => ({ ...prev, customer: value }))
          }
          placeholder={intl.formatMessage({
            id: 'workOrders.domain.complements.estimator',
          })}
        />
      </Col>

      <Col xs={24} md={6}>
        <InputDate
          placeholder={intl.formatMessage({
            id: 'workOrders.domain.complements.authorizationDate',
          })}
          value={
            queryParams?.authorizationDate
              ? moment(queryParams?.authorizationDate)
              : undefined
          }
          onChange={(value) =>
            setQueryParams((prev) => ({
              ...prev,
              authorizationDate: value?.toISOString(),
            }))
          }
        />
      </Col>
    </Row>
  );
}

export default ModalWorkOrdersExtraFilters;
